import classname from 'classnames/bind';

import { MochiLottie } from '@autopass-web/mochi-component';

import styles from './index.module.scss';
import lottieJson from './loading_mochi.json';

const cx = classname.bind(styles);

const LoadingMochi = ({ show = false }) => {
  const loadingMochiClass = cx({
    'loading-mochi': true,
    show,
  });

  return (
    <div className={loadingMochiClass}>
      <MochiLottie
        style={{ width: 70, height: 70 }}
        animationData={lottieJson}
        loop
      />
    </div>
  );
};

export default LoadingMochi;
